import React, { useMemo } from "react";
import { useWindowDimensions } from "react-native";

import SkeletonComparePlayerView from "./SkeletonComparePlayerView";

import useMobileScreen from "@/hooks/useMobileScreen";
import { useTheme } from "@/providers/ThemeProvider";
import chunkArrayWithPadding from "@/utils/chunkWithPadding";
import { skeletonColumnsForWidth } from "@/utils/skeletonColumns";

/**
 * Skeleton Compare Player Container
 *
 * Displays a loading skeleton placeholder for player comparison cards.
 * Maintains responsive grid layout while comparison data loads.
 * @module components/SkeletonComparePlayer/SkeletonComparePlayerContainer
 */
const SkeletonComparePlayerContainer = () => {
  const { width } = useWindowDimensions();
  const numCols = skeletonColumnsForWidth(width);
  const skeletonMetrics = chunkArrayWithPadding<boolean[]>(
    new Array(12).fill(true),
    numCols
  );
  const { resolvedTheme } = useTheme();
  const isDark = useMemo(() => resolvedTheme === "dark", [resolvedTheme]);
  const isSmallScreen = useMobileScreen();

  return (
    <SkeletonComparePlayerView
      skeletonMetrics={skeletonMetrics}
      isDark={isDark}
      isSmallScreen={isSmallScreen}
    />
  );
};

export default SkeletonComparePlayerContainer;
